// import {
//   useEffect,
//   useState,
//   type ComponentType,
// } from "react";

// import {
//   useNavigate,
//   useLocation,
// } from "react-router-dom";

// import { validatePassword }
// from "service1/authService";

// const HOST_TOKEN = "my-secret-token";

// type RemoteComponent =
//   ComponentType<Record<string, unknown>>;

// type UsePasswordReturn = {
//   password: string;
//   setPassword: (value: string) => void;
//   handleSubmit: () => Promise<void>;
//   isValid: boolean;
//   firstName: string;
//   Button: RemoteComponent | null;
//   Input: RemoteComponent | null;
//   loading: boolean;
// };

// export default function usePassword():
// UsePasswordReturn {

//   const [password, setPassword] =
//     useState<string>("");

//   const [Button, setButton] =
//     useState<
//       RemoteComponent | null
//     >(null);

//   const [Input, setInput] =
//     useState<
//       RemoteComponent | null
//     >(null);

//   const navigate = useNavigate();

//   const location = useLocation();

//   const { name = "" } =
//     (location.state as {
//       name?: string;
//     }) || {};

//   useEffect(() => {

//     import("remote_app/Button").then(
//       (mod) => {

//         setButton(
//           () =>
//             mod.default as RemoteComponent
//         );

//       }
//     );

//     import("inputfield/Input").then(
//       (mod) => {

//         setInput(
//           () =>
//             mod.default as RemoteComponent
//         );

//       }
//     );

//   }, []);

//   const handleSubmit =
//     async (): Promise<void> => {

//     if (!password) return;

//     try {

//       const userId =
//         sessionStorage.getItem(
//           "userId"
//         );

//       if (!userId) {

//         console.log(
//           "No userId found"
//         );

//         return;
//       }

//       const data =
//         await validatePassword(
//           {
//             userId: Number(userId),
//             password,
//           },
//           HOST_TOKEN
//         );

//       if (
//         Number(data.statusType) === 1
//       ) {

//         if (data.token) {

//           sessionStorage.setItem(
//             "token",
//             data.token
//           );

//         }

//         navigate("/dashboard");

//       } else {

//         console.log(
//           "Invalid password"
//         );

//       }

//     } catch (error) {

//       console.error(
//         "API error:",
//         error
//       );

//     }
//   };

//   return {
//     password,
//     setPassword,
//     handleSubmit,
//     isValid:
//       password.length > 0,
//     firstName: name,
//     Button,
//     Input,
//     loading: !Button || !Input,
//   };
// }







import {
  useEffect,
  useState,
  type ComponentType,
} from "react";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

import { validatePassword }
from "service1/authService";

type RemoteComponent =
  ComponentType<Record<string, unknown>>;

type UsePasswordReturn = {
  password: string;
  setPassword: (value: string) => void;
  handleSubmit: () => Promise<void>;
  isValid: boolean;
  firstName: string;
  Button: RemoteComponent | null;
  Input: RemoteComponent | null;
  loading: boolean;
  submitting: boolean;
};

export default function usePassword():
UsePasswordReturn {

  const [password, setPassword] =
    useState("");

  const [Button, setButton] =
    useState<RemoteComponent | null>(null);

  const [Input, setInput] =
    useState<RemoteComponent | null>(null);

  const [authorized, setAuthorized] =
    useState(false);

  const [validating, setValidating] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const { name = "" } =
    (location.state as {
      name?: string;
    }) || {};

  useEffect(() => {
    let mounted = true;

    const initialize = async () => {
      try {
        const token =
          sessionStorage.getItem(
            "AUTH_TOKEN"
          );

        const type =
          sessionStorage.getItem(
            "AUTH_TYPE"
          );

        if (!token || !type) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        const response =
          await fetch(
            `${import.meta.env.VITE_API_URL}/api/amibit/fwp/validate`,
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
              },
              body: JSON.stringify({
                token,
                type: Number(type),
              }),
            }
          );

        if (!response.ok) {
          throw new Error(
            `Validation failed: ${response.status}`
          );
        }

        const validationData =
          await response.json();

        console.log(
          "Validation Response:",
          validationData
        );

        if (
          !validationData ||
          validationData.success !== true
        ) {
          navigate("/", {
            replace: true,
          });
          return;
        }

        const buttonModule =
          await import(
            "remote_app/Button"
          );

        const inputModule =
          await import(
            "inputfield/Input"
          );

        if (!mounted) return;

        setButton(
          () =>
            buttonModule.default as RemoteComponent
        );

        setInput(
          () =>
            inputModule.default as RemoteComponent
        );

        setAuthorized(true);

      } catch (error) {

        console.error(
          "Token validation error:",
          error
        );

        navigate("/", {
          replace: true,
        });

      } finally {

        if (mounted) {
          setValidating(false);
        }

      }
    };

    initialize();

    return () => {
      mounted = false;
    };

  }, [navigate]);

  const handleSubmit =
    async (): Promise<void> => {

      if (submitting) return;

      if (!password.trim()) return;

      setSubmitting(true);

      try {

        const userId =
          sessionStorage.getItem(
            "userId"
          );

        const token =
          sessionStorage.getItem(
            "AUTH_TOKEN"
          ) || "";

        if (!userId) {
          console.log(
            "No userId found"
          );
          return;
        }

        const data =
          await validatePassword(
            {
              userId:
                Number(userId),
              password,
            },
            token
          );

        console.log(
          "Password Response:",
          data
        );

        if (
          Number(
            data.statusType
          ) === 1
        ) {

          if (data.token) {

            sessionStorage.setItem(
              "token",
              data.token
            );

          }

          setTimeout(() => {

            navigate(
              "/dashboard"
            );

          }, 500);

        } else {

          console.log(
            "Invalid password"
          );

        }

      } catch (error) {

        console.error(
          "API Error:",
          error
        );

      } finally {

        setSubmitting(false);

      }
    };

  return {
    password,
    setPassword,
    handleSubmit,
    isValid:
      password.length > 0,
    firstName: name,
    Button,
    Input,
    submitting,
    loading:
      validating ||
      !authorized ||
      !Button ||
      !Input,
  };
}